import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { PendingButtonStyled } from './styles/PendingButtonStyled'

export const PendingButton: FC<IBaseButtonProps> = PendingButtonStyled

PendingButton.displayName = 'PendingButton'
